import { ProfileAvatarFromUrl } from "@/common/ProfileAvatar";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { selectHighlights } from "./bidSlice";

export default function HighlightsOverview() {
    const highlights = useSelector(selectHighlights);
    return (
        <>
            <Grid container spacing={0.4}>
                {highlights.map((highlight, index) => (
                    <Grid item key={index}>
                        <ProfileAvatarFromUrl
                            imageUrl={highlight.profilePic}
                            name={highlight.accountName}
                            size={30}
                        />
                    </Grid>
                ))}
            </Grid>
        </>
    );
}
